import { render } from "./CommunityLicensing.vue?vue&type=template&id=16c89732"
import script from "./CommunityLicensing.vue?vue&type=script&lang=js"
export * from "./CommunityLicensing.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__